<template>
	<div id="app">
		<div class="pusher" :class="{ dimmed: isOpen }" @click="close">
			<div class="full height">
				<NavBarAlumnos />
				<div class="article">
					<BreadcrumbAlumnos />
					<div class="ui container">
						<div class="ui main intro container">
							<RouterView :key="$route.fullPath" />
						</div>
					</div>
				</div>
			</div>
			<portal-target name="semantic-ui-vue" />
			<notifications position="bottom right" class="mystyles" />
		</div>
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import BreadcrumbAlumnos from '@components/breadcrumb-alumnos.vue';
import NavBarAlumnos from '@components/nav-bar-alumnos.vue';
import Menu from '@constants/menu';
import Urls from '@constants';

export default {
	components: {
		BreadcrumbAlumnos,
		NavBarAlumnos,
	},
	data() {
		return {
			menu: Menu,
			oidcUser: null,
			animation: false
		};
	},
	computed: {
		...mapGetters('menu', ['isOpen', 'getAnimation']),
		listaMenu: function() {
			return this.menu.filter((x) => x.mostrar);
		}
	},
	watch: {
		isOpen: function() {
			setTimeout(() => {
				this.setAnimation(false);
			}, 1000);
		}
	},
	mounted() {
		window.addEventListener(
			'vuexoidc:accessTokenExpired',
			this.accessTokenExpired
		);
	},
	destroyed() {
		window.removeEventListener(
			'vuexoidc:accessTokenExpired',
			this.accessTokenExpired
		);
	},
	methods: {
		...mapActions('oidc', ['signOutOidc']),
		...mapActions('menu', ['changeOpen', 'setAnimation']),
		...mapActions('oidc', ['authenticateOidcPopup', 'removeOidcUser']),
		accessTokenExpired: function() {
			this.signOutOidc();
		},
		signOut: function() {
			this.removeOidcUser().then(() => {
				window.location =
					Urls.URL_AUTH + 'Account/Logout?redirectUrl=' + Urls.URL_APP;
			});
		},
		open: function($event) {
			this.setAnimation(true);
			$event.stopPropagation();
			this.changeOpen(true);
		},
		close: function($event) {
			this.setAnimation(true);
			this.changeOpen(false);
		}
	}
};
</script>
<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';
// Style loading bar between pages.yarb
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';

// Design variables and utilities from src/design.
@import '@design';

*,
*::before,
*::after {
	box-sizing: border-box;
}

body {
	background: $color-body-bg !important;
}
#app {
	@extend %typography-small;
}

// ===
// Base element styles
// ===

a,
a:visited {
	color: $color-link-text;
}

h1 {
	@extend %typography-xxlarge;
}

h2 {
	@extend %typography-xlarge;
}

h3 {
	@extend %typography-large;
}

h4 {
	@extend %typography-medium;
}

h5,
h6 {
	@extend %typography-small;
}

// ===
// Vendor
// ===

#nprogress .bar {
	background: $color-link-text;
}

#nprogress .spinner {
	display: none;
}

.mystyles {
	color: #fff;
	.primary {
		background: $background-primary !important;
		border-left-color: $background-primary-hover !important;
	}

	.warn {
		background: $background-warning !important;
		border-left-color: $background-warning-hover !important;
	}

	.error {
		background: $background-danger !important;
		border-left-color: $background-danger-hover !important;
	}

	.success {
		background: $background-success !important;
		border-left-color: $background-success-hover !important;
	}

	.info {
		background: $background-primary !important;
		border-left-color: $background-primary-hover !important;
	}
}
.left-icon {
	float: left !important;
	margin: 0 0.35714286em 0 0 !important;
}

.floated-right .icon {
	color: #fff;
}

.floated-right {
	position: fixed !important;
	right: 1em;
	bottom: 1em;
	color: #fff;
	background: $background-primary !important;
}
.ui.comments .comment .avatar i.icon {
	font-size: 2.5em;
}

.ui.comments .comment .avatar.personal i.icon {
	color: #32363c !important;
}

.ui.comments .comment .avatar.alumno i.icon {
	color: $background-danger !important;
}
body.pushable > #app > .pusher {
	background: #fff;
}
</style>
